var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148108",
    "data-name": "Rectangle 148108",
    width: 24,
    height: 24,
    transform: "translate(-2 -2)",
    fill: "#ff411a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alarm",
    transform: "translate(2 2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alarm-clock",
    transform: "translate(1.645 1.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11212",
    "data-name": "Group 11212",
    transform: "translate(1.767 2.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11211",
    "data-name": "Group 11211",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8332",
    "data-name": "Path 8332",
    d: "M62.143,79.017a6.575,6.575,0,1,0-9.494,0L50.94,81.295a.6.6,0,1,0,.956.717L53.553,79.8a6.527,6.527,0,0,0,7.687,0L62.9,82.012a.6.6,0,1,0,.956-.717Zm-4.149-4.537a.6.6,0,0,1-.12.359L56.081,77.23a.6.6,0,0,1-.956-.717L56.8,74.282V70.894a.6.6,0,0,1,1.2,0v3.586Z",
    transform: "translate(-50.821 -67.893)",
    fill: "#ff411a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11214",
    "data-name": "Group 11214",
    transform: "translate(0 0.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11213",
    "data-name": "Group 11213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8333",
    "data-name": "Path 8333",
    d: "M5.453,1.6A2.989,2.989,0,0,0,1.227,5.821a.6.6,0,0,0,.845,0L5.453,2.44A.6.6,0,0,0,5.453,1.6Z",
    transform: "translate(-0.378 -0.746)",
    fill: "#ff411a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11216",
    "data-name": "Group 11216",
    transform: "translate(11.433 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11215",
    "data-name": "Group 11215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8334",
    "data-name": "Path 8334",
    d: "M331.229.874a2.989,2.989,0,0,0-4.226,0,.6.6,0,0,0,0,.845L330.383,5.1a.6.6,0,0,0,.845,0A2.989,2.989,0,0,0,331.229.874Z",
    transform: "translate(-326.828 0.001)",
    fill: "#ff411a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.3421b6bd.svg";
export { ForwardRef as ReactComponent };